// Module
var code = "<td ng-repeat=\"column in ::tableOptions.columns track by $index\" name={{::column.cellName}} ng-hide={{::column.hide}} ng-style=\"{'text-align': column.textAlign}\" style=\"\"> <div nlg-template=createTemplate(column) nlg-template-scope=::getRowScope()></div> </td>";
// Exports
module.exports = code;